import PropTypes from 'prop-types';
import { useState } from 'react';
import classNames from 'classnames';
import SideBar from './sidebar/SideBar';
import Content from './content/Content';
import './Styles/general.less';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useLocalStorage } from '../../../../Components/useLocalStorage';

export default function Layout ({ children }) {
	const [isOpen, setOpen] = useState(true);
	const toggle = () => setOpen(!isOpen);
	const [isDark] = useLocalStorage('isDarkTheme', false);
	return (
		<div className={classNames('App wrapper', { dark: isDark })}>
			<SideBar toggle={toggle} isOpen={isOpen} />
			<Content toggle={toggle} isOpen={isOpen}>
				<div className="dashboard">
					{children}
				</div>
			</Content>
		</div>
	);
}

Layout.propTypes = {
  children: PropTypes.element
};
